module.exports = __webpack_public_path__ + "95285381e4d37b0b415bc02870441747.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/advisory/So_Huu_Tri_Tue.svg
// module id = ./assets/images/advisory/So_Huu_Tri_Tue.svg
// module chunks = 0